import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'
import formatSubresources from '@tabeo/sharpei/utils/formatSubresources'

class Comments extends Resource {
  async fetch() {
    const subResources = formatSubresources([])
    const { endpoint, order = 'id:desc', limit = 1000 } = this.params
    if (!endpoint) {
      throw new Error('Comments resurce must have an `endpoint` param set.')
    }
    const { comments } = await api.get(
      `${endpoint}?${subResources}&order=${order}&limit=${limit}`
    )

    this.data = comments
    return comments
  }

  create = async content => {
    const response = await api.post(`${this.params.endpoint}`, { content })
    await this.fetch()
    return response
  }

  remove = async ({ id }) => {
    const response = await api.delete(`/comments/${id}`, {})
    await this.fetch()
    return response
  }
}

export default Comments
export const useComments = createResourceHook(Comments)
